import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import SignOut from '../modals/SignOut';
import { menuIcon } from '../../assets/images/images';
import ChangePassword from '../modals/ChangePassword';
import { NUMBERS } from '../../resources/number-constants';
import { getValue, storeValue } from '../../utility/helpers';
import PlanDetail from '../modals/PlanDetail';

const DropdownMenu = ({ assignedTier = {} }: any) => {
  const navigate = useNavigate();
  const isAdmin = getValue('adminAuthToken');
  const userRole = getValue('userType');
  const [showSignOut, setShowSignOut] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [viewPlan, setViewPlan] = useState(false);

  const navigateTo = (route: any) => {
    navigate(route);
  };

  const backToAdmin = () => {
    if (isAdmin) {
      storeValue('authToken', isAdmin);
      if (userRole !== undefined) {
        storeValue('userType', NUMBERS.THREE);
      }
    }
    localStorage.removeItem('adminAuthToken');
    navigate('/adminDashboard');
  };

  const handleToggle = (isOpen: boolean) => {
    if (isOpen) {
      document.body.classList.add('dropdown-open');
    } else {
      document.body.classList.remove('dropdown-open');
    }
  };

  return (
    <>
      <div className="menu-dropdown">
        <DropdownButton
          align="end"
          drop="down"
          id="dropdown-item-button"
          title={<img src={menuIcon} alt="dot" />}
          onToggle={handleToggle}
        >
          <Dropdown.ItemText>Profile Settings</Dropdown.ItemText>
          {isAdmin && (
            <Dropdown.Item as="button" onClick={backToAdmin}>
              Switch to Admin
            </Dropdown.Item>
          )}
          <Dropdown.Item
            as="button"
            onClick={() => navigateTo('/edit-company-profile')}
          >
            Edit Profile
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            onClick={() => setShowChangePassword(true)}
          >
            Change Password
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            onClick={() => setViewPlan(true)}
          >
            View Plan
          </Dropdown.Item>
          {/* <Dropdown.Item as="button">Help</Dropdown.Item> */}
          <Dropdown.Item
            as="button"
            onClick={() => navigateTo('/terms-service')}
          >
            Terms of Service
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            onClick={() => navigateTo('/privacy')}
          >
            Privacy Policy
          </Dropdown.Item>
          {!isAdmin && (
            <Dropdown.Item
              as="button"
              className="red-color"
              onClick={() => setShowSignOut(true)}
            >
              Sign Out
            </Dropdown.Item>
          )}
        </DropdownButton>
      </div>

      {showSignOut && (
        <SignOut showSignOut={showSignOut} setShowSignOut={setShowSignOut} />
      )}

      {showChangePassword && (
        <ChangePassword
          showChangePassword={showChangePassword}
          setShowChangePassword={setShowChangePassword}
        />
      )}

      {viewPlan && (
        <PlanDetail viewPlan={viewPlan} setViewPlan={setViewPlan} assignedTier={assignedTier}/>
      )}
    </>
  );
};

export default DropdownMenu;
